import { render, staticRenderFns } from "./CourseDetail.vue?vue&type=template&id=68fa5f63&scoped=true"
import script from "./CourseDetail.vue?vue&type=script&lang=js"
export * from "./CourseDetail.vue?vue&type=script&lang=js"
import style0 from "./CourseDetail.vue?vue&type=style&index=0&id=68fa5f63&prod&scoped=true&lang=css"
import style1 from "./CourseDetail.vue?vue&type=style&index=1&id=68fa5f63&prod&lang=less&scoped=true"
import style2 from "./CourseDetail.vue?vue&type=style&index=2&id=68fa5f63&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68fa5f63",
  null
  
)

export default component.exports